import React from 'react';
import Presenter from './Presenter';
import MobilePresenter from './MobilePresenter';
import {Default,Mobile} from '../../Sizes';
import Container from './Container';



const HomeContent = (props) => {
	return <Container 
		{...props}
		render={(containerProps,otherProps)=><React.Fragment>
			<Default>
				<Presenter 
					{...containerProps}
					{...otherProps}
				/>
			</Default>
			<Mobile>
				<MobilePresenter 
					{...containerProps}
					{...otherProps}
				/>
			</Mobile>
		</React.Fragment>} />;
};
export default HomeContent;